import React from 'react';
import { datadogRum } from '@datadog/browser-rum';
import ClassSearch from './ClassSearch';
import CatalogSearch from './CatalogSearch';
import Admin from './admin/AdminTabs';
import Logout from './auth/Logout';
import AdvancedSearch from './AdvancedSearch';
import AdvancedSearchCatalog from './AdvancedSearchCatalog';
import serviceauth from './auth/serviceauth';
import Favorites from './Favorites';
// import InstructorDirectoryRedirect from './components/InstructorDirectoryRedirect'

//CSS
import '@asu/unity-bootstrap-theme/dist/css/unity-bootstrap-theme.bundle.css';

import {
  BrowserRouter as Router,
  Route,
  // Switch,
  Redirect,
  Switch,
  useHistory,
} from 'react-router-dom';

import ReactGAModule from 'react-ga4';
const ReactGA = [
  ReactGAModule?.default?.default,
  ReactGAModule?.default,
  ReactGAModule,
].find((candidate) => typeof candidate?.initialize === 'function');
import GoogleTagManager from './components/GoogleTagManager';
import ClassFAQ from './ClassFAQ';
import ClassMaterials from './ClassMaterials';
const ENV = process.env.REACT_APP_HOST_ENV;

// ================= Datadog RUM (core SDK only, manual routing integration) =================
// Expect the following env vars to be provided at build time (do NOT hardcode secrets):
//   REACT_APP_DD_APP_ID
//   REACT_APP_DD_CLIENT_TOKEN
//   REACT_APP_DD_SITE (e.g. datadoghq.com, datadoghq.eu)
//   REACT_APP_DD_ENV (e.g. prod, qa, dev)
//   REACT_APP_DD_SERVICE (e.g. catalog-class-search)
// Provide safe fallbacks so local/dev doesn't break if unset.
const DD_APP_ID = 'a8dcea16-43f9-4cf5-8123-42a2a92113b4';
const DD_CLIENT_TOKEN = 'pub08f3ab481c88fe4eb2bdaa0be609ee1f';
const DD_SITE = 'datadoghq.com';
const DD_ENV = ENV;
const DD_SERVICE = 'catalog-microservices';

if (DD_APP_ID && DD_CLIENT_TOKEN && !window.__DD_RUM_INITIALIZED__) {
  try {
    datadogRum.init({
      applicationId: DD_APP_ID,
      clientToken: DD_CLIENT_TOKEN,
      site: DD_SITE,
      env: DD_ENV,
      service: DD_SERVICE,
      version: process.env.REACT_APP_BUILD_VERSION || undefined,
      sessionSampleRate: 100, // keep RUM metrics
      sessionReplaySampleRate: 0, // do not automatically record replays
      startSessionReplayRecordingManually: true, // require explicit start
      trackResources: true,
      trackLongTasks: true,
      trackUserInteractions: true,
      defaultPrivacyLevel: 'mask',
      silentMultipleInit: true,
      allowedTracingUrls: [process.env.REACT_APP_API_URL],
      traceSampleRate: 100,
      beforeSend(event) {
        // remove user PII from events
        if (event?.user) {
          event.user = { id: event.user.id || 'anon' };
        }

        // Safety net - block all external tracking and non-ASU URLs
        const eventStr = JSON.stringify(event);
        if (
          !eventStr.includes('asu.edu') ||
          eventStr.includes('adservice.google.com') ||
          eventStr.includes('google-analytics.com') ||
          eventStr.includes('googletagmanager.com') ||
          eventStr.includes('doubleclick.net') ||
          eventStr.includes('googlesyndication.com') ||
          eventStr.includes('googleadservices.com')
        ) {
          return false;
        }

        return true;
      },
    });

    // DO NOT call startSessionReplayRecording() here.
    // Only call it manually when you purposely need a replay and you've verified no PII.
    window.__DD_RUM_INITIALIZED__ = true;
  } catch (e) {
    console.error('Datadog RUM init error', e);
  }
} else if (!DD_APP_ID || !DD_CLIENT_TOKEN) {
  // eslint-disable-next-line no-console
  console.warn(
    'Datadog RUM not initialized: missing APP_ID or CLIENT_TOKEN environment variables'
  );
}
// ===========================================================================================

function getGA() {
  return ENV === 'prod' ? 'G-TEHJR60KD9' : ' ';
}

// Setup GTM, second set requested
let gtmId = '';
let gtmId2 = '';
let gtmVars;
let gtmVars2;

if (ENV === 'prod') {
  gtmId = 'GTM-KDWN8Z';
} else if (ENV === 'qa') {
  gtmId = 'GTM-P5W4BQM5';
  gtmId2 = 'GTM-KDWN8Z';
  gtmVars = { gtm_auth: 'cs_WfLDN5e6CYIV-lF45vQ', gtm_preview: 'env-4' };
  gtmVars2 = { gtm_auth: 'lrxv_8yM8NvDPRSSlufJMw', gtm_preview: 'env-1843' };
} else {
  // dev
  gtmId = 'GTM-P5W4BQM5';
  gtmVars = { gtm_auth: 'CohKJvRZlzbwSiT-HyNxKg', gtm_preview: 'env-3' };
}

ReactGA.initialize(getGA());

const ServiceAuthRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => handleAuth(<Component {...props} />, props)}
  />
);

function handleAuth(component, props) {
  if (props.history.location.hash !== '') {
    return component;
  } else if (props.history.action === 'PUSH') {
    // console.log("Just filtering, do nothing")
    return component;
  } else if (
    sessionStorage.getItem(serviceauth.SS_JWT_TOKEN) &&
    (sessionStorage.getItem(serviceauth.SS_NAME) === null ||
      sessionStorage.getItem(serviceauth.SS_NAME) === '')
  ) {
    // console.log("getting user data 2")
    serviceauth.authComplete();
    return component;
  } else if (sessionStorage.getItem(serviceauth.SS_PASSIVE_AUTH)) {
    // console.log("passive auth: "+JSON.stringify(props))
    sessionStorage.removeItem(serviceauth.SS_PASSIVE_AUTH);
    return component;
  } else {
    //	console.log("here 3")
    serviceauth.reauth();
  }
}

const ServiceAuthResponseRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => handleAuthResponse(props)} />
);

function handleAuthResponse(props) {
  //console.log(JSON.stringify(props))
  if (
    serviceauth.getParam('code') &&
    (sessionStorage.getItem(serviceauth.SS_JWT_TOKEN) === null ||
      sessionStorage.getItem(serviceauth.SS_JWT_TOKEN) === '')
  ) {
    //console.log("code is in params")
    var code = serviceauth.getParam('code');
    var state = serviceauth.getParam('state');

    serviceauth.handleOauthCode(
      code,
      state,
      function () {
        //console.log("getting user data 1")
        serviceauth.authComplete();
      },
      function (errTxt) {
        // TODO: UI
        console.log('ERROR: ' + errTxt);
        serviceauth.reauth();
      }
    );
    //return redirect
  } else if (serviceauth.getParam('error') === 'unauthenticated') {
    //console.log("coming from serviceaauth with error = unauthenticated")
    sessionStorage.setItem(serviceauth.SS_PASSIVE_AUTH, 'Y');
  }
  //console.log("return redirect")
  var search =
    sessionStorage.getItem(serviceauth.SS_SEARCH_PARAMS) !== null
      ? sessionStorage.getItem(serviceauth.SS_SEARCH_PARAMS)
      : '';

  sessionStorage.removeItem(serviceauth.SS_SEARCH_PARAMS);

  //console.log(search)
  const mySearch = search.split('?');
  if (mySearch !== null && mySearch.length > 1) {
    //console.log("Redirecting with paramaters" + JSON.stringify(newState))
    //console.log("Redirecting with paramaters props: "+JSON.stringify(props))

    return (
      <Redirect
        to={{
          pathname: mySearch[0],
          //state: { referrer: currentLocation },
          search: '?' + mySearch[1],
        }}
      />
    );
  } else {
    //  console.log("Redirecting without paramaters")
    return (
      <Redirect
        to={{
          pathname: mySearch[0],
          state: { from: props.location },
          //search:search
        }}
      />
    );
  }
}

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      sessionStorage.getItem(serviceauth.SS_JWT_TOKEN) ? (
        <Component {...props} />
      ) : (
        window.location.replace(serviceauth.redirectToServiceauthUrl(true))
      )
    }
  />
);

const AllRoutesRedirect = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      <Redirect
        to={{
          pathname: '/catalog/classes',
          state: { from: props.location },
        }}
      />
    )}
  />
);

const LocalRedirect = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      myLocalRedirect(
        <Redirect
          to={{
            pathname: '/catalog/classes',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

const LocalRedirectAdvanced = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      myLocalRedirect(
        <Redirect
          to={{
            pathname: '/catalog/advanced',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

function myLocalRedirect(redirect) {
  if (
    window.location.href.indexOf('https://localhost.asu.edu:3000/local') >= 0
  ) {
    sessionStorage.setItem(serviceauth.SS_PASSIVE_AUTH, 'Y');
    return redirect;
  }
}

const CatalogLocalRedirect = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      myLocalRedirect(
        <Redirect
          to={{
            pathname: '/catalog/courses',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

const FaqLocalRedirect = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      myLocalRedirect(
        <Redirect
          to={{
            pathname: '/catalog/faq',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

const MaterialsLocalRedirect = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      myLocalRedirect(
        <Redirect
          to={{
            pathname: '/catalog/materials',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

const FavoritesLocalRedirect = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      myLocalRedirect(
        <Redirect
          to={{
            pathname: '/catalog/favorites',
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

const App = {
  App() {
    // console.log(document.cookie.split(";"))
    // sessionStorage.setItem(serviceauth.SS_JWT_TOKEN, "");
    // sessionStorage.setItem(serviceauth.SS_VIEW_AS_USER,"")
    // sessionStorage.setItem(serviceauth.SS_VIEW_AS,"N")
    // sessionStorage.setItem(serviceauth.SS_IS_ONLINE,"N")
    // sessionStorage.setItem(serviceauth.SS_CAREER,"")
    // sessionStorage.setItem(serviceauth.SS_NAME, 'Laura');

    return (
      <Router>
        {gtmId2 ? (
          <GoogleTagManager
            gtmId={gtmId}
            gtmId2={gtmId2}
            gtmVars={gtmVars}
            gtmVars2={gtmVars2}
          />
        ) : (
          <GoogleTagManager gtmId={gtmId} gtmVars={gtmVars} />
        )}
        <Routes />
      </Router>
    );
  },
};

function Routes() {
  const history = useHistory();

  React.useEffect(() => {
    trackPageView(); // To track the first pageview upon load
    history.listen(trackPageView); // To track the subsequent pageviews
    // Manual RUM view tracking (React Router v5) - initial + subsequent
    datadogRum.startView(history.location.pathname + history.location.search);
    const unlisten = history.listen((location) => {
      datadogRum.startView(location.pathname + location.search);
    });
    return () => {
      if (unlisten) unlisten();
    };
  }, [history]);

  function trackPageView() {
    // New with react-ga4, remove pageview() and use send() with object instead
    ReactGA.send({
      hitType: 'pageview',
      page: window.location.pathname + window.location.search,
      title: window.document.title,
    });
  }

  return (
    <Switch>
      <Route exact path="/" component={AllRoutesRedirect} />
      {/* <Route path="/login" component={Login} /> */}
      <Route path="/logout" component={Logout} />
      {/* <Route path="/instructor" component={InstructorDirectoryRedirect} /> */}
      <PrivateRoute path="/catalog/admin" component={Admin} />
      <Route exact path="/catalog" component={ServiceAuthResponseRoute} />{' '}
      {/*handle response from serviceauth, redirects to /catalog/classes */}
      <ServiceAuthRoute path="/catalog/classes" component={ClassSearch} />
      <LocalRedirect exact path="/local" component={ClassSearch} />
      <CatalogLocalRedirect
        exact
        path="/local/catalog"
        component={CatalogSearch}
      />
      <ServiceAuthRoute path="/catalog/courses" component={CatalogSearch} />
      <LocalRedirectAdvanced
        exact
        path="/localadvanced"
        component={AdvancedSearch}
      />
      <ServiceAuthRoute
        exact
        path="/catalog/advanced"
        component={AdvancedSearch}
      />
      <ServiceAuthRoute
        exact
        path="/catalog/advanced/courses"
        component={AdvancedSearchCatalog}
      />
      <FaqLocalRedirect exact path="/local/faq" component={ClassFAQ} />
      <ServiceAuthRoute path="/catalog/faq" component={ClassFAQ} />
      <ServiceAuthRoute path="/catalog/favorites" component={Favorites} />
      <FavoritesLocalRedirect
        exact
        path="/local/favorites"
        component={Favorites}
      />
      <MaterialsLocalRedirect
        exact
        path="/local/materials"
        component={ClassMaterials}
      />
      <ServiceAuthRoute path="/catalog/materials" component={ClassMaterials} />
      {/* <Route exact path='/FAQ' component={() => {
          window.location.href = 'https://docs.google.com/document/d/e/2PACX-1vRskOVXbAyDzc_rSXaKzqGouKxajil92K2InHxL43vzAkqz6Vp3vpPoKkZWdhiDBYcPnHicMCnRRETl/pub';
          return null;
        }}/> */}
      {/* <PrivateRoute path='/catalog/courses' component={CatalogSearch} /> */}
    </Switch>
  );
}

// function AllRoutesRedirect() {
//   return <Redirect
//   to={{
//     pathname: "/catalog/classes",
//     state: { from: location }
//   }}
// />
// }

export default App;
